import styled from 'styled-components'
import { Button, themeColor } from '@elparking/components'

const FilterButton = styled(Button.bordered)`
    height: auto;
    border: ${({selected}) => selected ? '2px' : '1px'} solid ${({selected}) => selected ? themeColor('main') : themeColor('gray20')};
    border-radius: 4px;
    color: ${({selected}) => selected ? themeColor('main') : themeColor('gray')};
    background: ${themeColor('white')};

    &:hover {
        background: ${({selected}) => selected ? themeColor('darkMain') : themeColor('main60')};
        color: ${themeColor('white')};
    }
`
export default FilterButton
